export default __webpack_public_path__ + "static/media/headset8.c483c176.jfif";